// 妖精动漫网 - 作品专题数据
export interface AnimeWork {
  id: string;
  name: string;
  subtitle: string;
  year: string;
  genre: string;
  rating: number;
  episodes: number;
  characterCount: number;
  description: string;
  image: string;
  tags: string[];
}

export const works: AnimeWork[] = [
  {
    id: 'wind-spirit',
    name: '风之精灵使',
    subtitle: 'Wind Spirit Master',
    year: '2019',
    genre: '冒险 / 奇幻',
    rating: 9.1,
    episodes: 26,
    characterCount: 12,
    description: '讲述少女琳娅·夜莺登上「岚之塔」成为风之精灵使的故事。作品以清爽的云端冒险与高燃空战著称，风系战斗的运镜堪称教科书级别，是入坑妖精类作品的绝佳起点。',
    image: 'https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20wind%20spirit%20adventure%20series%2C%20young%20mage%20flying%20through%20giant%20cloud%20towers%20with%20wind%20currents%2C%20epic%20fantasy%20sky%20battle%2C%20soft%20painterly%20anime%20style%2C%20emerald%20and%20gold%20palette%2C%20clean%20minimal%20composition&width=900&height=600&seq=work-wind&orientation=landscape',
    tags: ['冒险', '空战', '高燃', '少女成长'],
  },
  {
    id: 'flower-crown',
    name: '花冠物语',
    subtitle: 'Flower Crown Tale',
    year: '2020',
    genre: '恋爱 / 奇幻',
    rating: 8.8,
    episodes: 24,
    characterCount: 15,
    description: '蔷薇妖精女王芙洛拉守护「万花庭院」的温柔物语。以四季流转的花语为线索，交织治愈与成长，画风细腻唯美，花系角色的情感刻画深入人心。',
    image: 'https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20flower%20fairy%20romance%20series%2C%20golden%20haired%20fairy%20queen%20in%20a%20blooming%20magical%20garden%20with%20roses%20and%20floating%20petals%2C%20soft%20painterly%20anime%20style%2C%20warm%20cream%20and%20gold%20palette%2C%20clean%20minimal%20composition&width=900&height=600&seq=work-flower&orientation=landscape',
    tags: ['恋爱', '治愈', '四季花语', '唯美'],
  },
  {
    id: 'star-field',
    name: '星野之森',
    subtitle: 'Star Field Forest',
    year: '2021',
    genre: '奇幻 / 冒险',
    rating: 9.3,
    episodes: 30,
    characterCount: 18,
    description: '围绕星之精灵与森林守护者展开的宏大群像剧。神秘的引路者艾露、元气的守护者提亚与万千生灵交织成一张星图，世界观宏大、伏笔精妙，是本站收录角色最多的作品。',
    image: 'https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20an%20epic%20star%20forest%20fantasy%20series%2C%20silver%20haired%20spirit%20among%20glowing%20ancient%20trees%20and%20starlit%20canopy%2C%20fireflies%20and%20constellations%2C%20soft%20painterly%20anime%20style%2C%20emerald%20and%20gold%20palette%2C%20clean%20minimal%20composition&width=900&height=600&seq=work-star&orientation=landscape',
    tags: ['群像剧', '宏大世界观', '星图', '伏笔'],
  },
  {
    id: 'moonlight',
    name: '月光回廊',
    subtitle: 'Moonlight Corridor',
    year: '2022',
    genre: '悬疑 / 奇幻',
    rating: 8.6,
    episodes: 22,
    characterCount: 14,
    description: '暗夜精灵的悬疑群像。刺客诺拉与祭司尤娜在「月光回廊」中追寻被诅咒的真相，暗系美学与烧脑剧情兼具，结局反转令人久久回味。',
    image: 'https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20mysterious%20moonlit%20corridor%20fantasy%20series%2C%20dark%20elf%20assassin%20and%20moon%20priestess%20under%20eerie%20blue%20moonlight%2C%20silhouettes%20and%20shadow%20blades%2C%20soft%20painterly%20anime%20style%2C%20deep%20emerald%20and%20silver%20palette%2C%20clean%20minimal%20composition&width=900&height=600&seq=work-moon&orientation=landscape',
    tags: ['悬疑', '暗系', '反转', '群像'],
  },
  {
    id: 'abyss-mirror',
    name: '深渊水镜',
    subtitle: 'Abyss Mirror',
    year: '2024',
    genre: '奇幻 / 冒险',
    rating: 8.9,
    episodes: 26,
    characterCount: 16,
    description: '以深海结界为舞台的元素物语。咏者汐音与地火使者塞拉在深渊之中化解失衡，水火相济的羁绊令人动容，是近年口碑升温的力作。',
    image: 'https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20deep%20sea%20elemental%20fantasy%20series%2C%20teal%20haired%20singer%20and%20fire%20spirit%20girl%20facing%20each%20other%20in%20an%20underwater%20boundary%2C%20bubbles%20and%20light%20rays%2C%20soft%20painterly%20anime%20style%2C%20emerald%20and%20gold%20palette%2C%20clean%20minimal%20composition&width=900&height=600&seq=work-abyss&orientation=landscape',
    tags: ['深海', '水火', '羁绊', '口碑'],
  },
  {
    id: 'phantom-night',
    name: '幻夜妖精',
    subtitle: 'Phantom Night Fairy',
    year: '2023',
    genre: '校园 / 奇幻',
    rating: 8.4,
    episodes: 20,
    characterCount: 13,
    description: '发生在现代都市夜晚的轻奇幻。金穗的麦田、极光的剑刃与形形色色的妖精共同守护「幻夜」的秩序，轻松温馨又暗藏深意，适合轻松入坑。',
    image: 'https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20light%20urban%20fantasy%20series%20at%20night%2C%20golden%20wheat%20field%20and%20glowing%20aurora%20sword%20in%20a%20modern%20city%20nightscape%2C%20fairy%20lights%2C%20soft%20painterly%20anime%20style%2C%20gold%20and%20emerald%20palette%2C%20clean%20minimal%20composition&width=900&height=600&seq=work-phantom&orientation=landscape',
    tags: ['都市', '轻奇幻', '温馨', '守护'],
  },
];